/**
 * Labstep
 *
 * @module core/Collapsible/Card
 * @desc Card component that contains a number of CollapsibleItem
 */

import classNames from 'classnames';
import { CollapsibleCardItemContainer as CollapsibleCardItem } from 'labstep-web/core/Collapsible/Card/Item';
import type React from 'react';
import type { ICollapsibleCardItemContainerProps } from './Item/types';
import styles from './styles.module.scss';
import type { ICollapsibleCardProps } from './types';

export const CollapsibleCard: React.FC<ICollapsibleCardProps> & {
  Item: React.FC<ICollapsibleCardItemContainerProps>;
} = ({ children, attached }) => (
  <div
    data-testid="collapsible-card"
    data-cy="core/Collapsible"
    className={classNames({ [styles.container]: !attached })}
  >
    {children}
  </div>
);

CollapsibleCard.Item = CollapsibleCardItem;
